(function () {
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    const url = args[0];

    if (typeof url === "string" && url.includes("/cart/update.js")) {

      document.dispatchEvent(
        new CustomEvent("cart:updated:new", {
          detail: { url }
        })
      );
    }

    return response;
  };
})();

